import React from 'react';
import { Button, DataTable, Link, Text } from '@shopify/polaris';
import { ViewIcon } from '@shopify/polaris-icons';
import CustomBadge from '#client/components/common/CustomBadge/CustomBadge';
import { handleSort } from '#client/utils/helpers';

/**
 *
 * @param {*} param
 * @param {Array} param.asnRows - Array of ASN rows to be displayed in the table
 * @param {Function} param.navigate - Function to navigate to a different route
 * @param {number} param.asnSortColumnIndex - Current sorted column index for the ASNs
 * @param {string} param.asnSortDirection - Current sort direction for the ASNs
 * @param {Function} param.setAsnSortColumnIndex - Function to set the ASN sort column index
 * @param {Function} param.setAsnSortDirection - Function to set the ASN sort direction
 * @param {Function} param.setAsnRows - Function to set the ASN rows state
 * @param {*} param.parentData - Parent PO data passed to navigation route
 * @description Displays a sortable table of Advanced Shipping Notices.
 * @returns
 */
const AdvancedShippingNoticesTable = ({ asnRows, navigate, asnSortColumnIndex, asnSortDirection, setAsnSortColumnIndex, setAsnSortDirection, setAsnRows, parentData }) => {
    const columnKeyMap = ['asnId', 'auditRequired', 'expectedDate', 'quantityOrdered'];

    return (
        <>
            <Text variant="headingLg">Advanced Shipping Notices</Text>
            <DataTable
                columnContentTypes={['text', 'text', 'text', 'text', 'text']}
                headings={['ASN ID', 'Audit Required', 'Expected Date', 'Qty', 'Actions']}
                rows={asnRows.map((row, index) => [
                    <Link
                        key={`asn-${index}`}
                        onClick={() =>
                            navigate(`advanced-shipping-notice/${row.advancedShippingNoticeId}`, {
                                state: {
                                    purchaseOrderId: row.advancedShippingNoticeId,
                                    parentData: parentData,
                                },
                            })
                        }
                        textAlign="left"
                        monochrome
                        removeUnderline
                        style={{ textDecoration: 'none' }}
                    >
                        {row.asnId}
                    </Link>,
                    <CustomBadge key={`asn-${index}`} status={row.auditRequired ? 'Audit Required' : null} />,
                    row.expectedDate,
                    row.quantityOrdered,
                    <Button
                        key={`asn-btn-${index}`}
                        onClick={() =>
                            navigate(`advanced-shipping-notice/${row.advancedShippingNoticeId}`, {
                                state: {
                                    purchaseOrderId: row.advancedShippingNoticeId,
                                    parentData: parentData,
                                },
                            })
                        }
                        icon={ViewIcon}
                        variant="monochromePlain"
                    />,
                ])}
                sortable={[true, true, true, true, false]}
                defaultSortDirection="none"
                onSort={(index, direction) => {
                    setAsnSortColumnIndex(index);
                    setAsnSortDirection(direction);
                    const sorted = handleSort(asnRows, index, direction, columnKeyMap);
                    setAsnRows(sorted);
                }}
                sortDirection={asnSortDirection}
                sortedColumnIndex={asnSortColumnIndex}
            />
        </>
    );
};

export default AdvancedShippingNoticesTable;
